import { Injectable } from '@angular/core';
import { RouterPathParams } from '../types/router-path-params';
import { RouterLinkParts } from '../types/router-link-parts';
import { RouterLinkPart } from '../types/router-link-part';
import { RouterPathParam } from '../enums/router-path-param';
import { RouterPathParamValueNotFoundException } from '../exceptions/router-path-param-value-not-found.exception';
import { Nullable } from '@core/utils/types/nullable/nullable';
import { isNullable } from '@core/utils/types/nullable/is-nullable';
import { RouterLink } from '../types/router-link';
import { keyByValue } from '@core/utils/types/enums/key-by-value';

@Injectable({
  providedIn: 'root',
})
export class RouterLinkParamsProcessorService {
  process(
    parts: RouterLinkParts,
    params?: Nullable<RouterPathParams>,
  ): RouterLink {
    return parts.map((part: RouterLinkPart) => {
      if (!this.isRouterPathParam(part)) {
        return part;
      }

      if (!isNullable(params)) {
        const value = params[part];

        if (!isNullable(value)) {
          return value;
        }
      }

      const name = keyByValue(part, RouterPathParam);

      throw new RouterPathParamValueNotFoundException(
        `No value was passed for the router path parameter ${name}.`,
      );
    });
  }

  private isRouterPathParam(part: RouterLinkPart): part is RouterPathParam {
    return (Object.values(RouterPathParam) as string[]).includes(part);
  }
}
